import { render, staticRenderFns } from "./ordersGoods.vue?vue&type=template&id=a0a0092a&"
import script from "./ordersGoods.vue?vue&type=script&lang=js&"
export * from "./ordersGoods.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports